import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';
import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';
import { OMT_UI_AvatarWithFrame } from '../../../OMT_UI/FriendsList/OMT_UI_AvatarWithFrame';

export const POSTCARD_STATE = {
  CLAIM: 0,
  SEND: 1,
};

/**
 * The individual post cards that are shown in window_eventPostcard.
 * Its totally not like a friendship chest card.
 * @author Sandra Koo
 */
export default class EventPostcard extends Phaser.Group {
  constructor(cardDimensions) {
    super(game, null);

    this.signals = {
      onClick: new Phaser.Signal(),
    };
    const dimensions = {
      width: cardDimensions.width || 500,
      height: cardDimensions.height || 800,
    };

    this.nextCard = undefined; // Keep track of the card next of it
    this.prevCard = undefined; // Keep track of the card before it
    this.index = 0; // The index of the card
    this.fillContainer = undefined; // The fill container that hides and shows often
    this._button = undefined; // The button that gets clicked
    this._state = undefined; // The current state of the card. Doesn't change much
    this._card = undefined; // The card asset that isn't this
    this._subFill = undefined; // The container inside the fill container
    this._border = undefined; // The card border background
    this._postcardSlice = undefined; // The slices, taken from G.OMTSettings
    this._innerDimensions = undefined; // A Phaser.Rectangle that has the inner dimensions

    this._drawCard(dimensions);
  }

  /**
   * Dessssssstroy!
   */
  destroy() {
    this.signals.onClick.dispose();

    if (this._button) {
      this._button.destroy();
    }

    super.destroy();
  }

  getBounds() {
    return this._card.getBounds();
  }

  /**
   * Draws the bare minimum to be called a postcard card
   */
  _drawCard(cardDimensions) {
    // visual container
    this._card = new Phaser.Group(game, this);
    this._postcardSlice = JSON.parse(JSON.stringify(G.OMTsettings.postcardEvent.cardData.border.slices));

    // border
    const borderOffset = {
      x: (G.OMTsettings.postcardEvent.cardData.border.offset && G.OMTsettings.postcardEvent.cardData.border.offset.x) ? G.OMTsettings.postcardEvent.cardData.border.offset.x : 0,
      y: (G.OMTsettings.postcardEvent.cardData.border.offset && G.OMTsettings.postcardEvent.cardData.border.offset.y) ? G.OMTsettings.postcardEvent.cardData.border.offset.y : 0,
    };
    this._border = new PhaserNineSlice.NineSlice(borderOffset.x, borderOffset.y, 'eventPostcard', 'popup_eventPostcard', cardDimensions.width, cardDimensions.height, this._postcardSlice);
    this._border.anchor.set(0.5);
    this._card.addChild(this._border);
    if (G.OMTsettings.postcardEvent.cardData.border.extra) {
      const cardCenter = {
        x: borderOffset.x - (this._card.width / 2),
        y: borderOffset.y - (this._card.height / 2),
      };
      for (let i = 0; i < G.OMTsettings.postcardEvent.cardData.border.extra.length; i++) {
        const extraData = G.OMTsettings.postcardEvent.cardData.border.extra[i];
        const extraDetail = G.makeImage(0, 0, extraData.asset, 0.5, this);
        extraDetail.x = cardCenter.x + (this._card.width * (extraData.align[0] || 0));
        extraDetail.y = cardCenter.y + (this._card.height * (extraData.align[1] || 0));
      }
    }

    // The dimensions of the inner side of the card
    this._innerDimensions = new Phaser.Rectangle(this._postcardSlice.left, this._postcardSlice.top,
      this._border.width - this._postcardSlice.right - this._postcardSlice.left, this._border.height - this._postcardSlice.bottom - this._postcardSlice.top);

    // The container that holds stuff
    this.fillContainer = new Phaser.Group(game, this._card);
    this._subFill = new Phaser.Group(game, this.fillContainer);

    // A mask to keep assets within the card
    const cardMask = new Phaser.Graphics(game);
    cardMask.beginFill(0, 0.5);
    cardMask.drawRect(-this._border.width / 2, -this._border.height / 2, this._border.width, this._border.height);
    cardMask.endFill();

    this._card.addChild(cardMask);
    cardMask.mask = cardMask;
  }

  /**
   * Fills the card with the given data. Much simpler than friendship chest card
   * @param {Object} cardData
   * @param {POSTCARD_STATE} cardData.state The state of the card
   * @param {number} cardData.index  The index of the card
   * @param {string} cardData.speechText The string for the speech bubble in the post card avatar
   * @param {string} cardData.cardCaption The caption just above the button
   * @param {string} cardData.cardTitle The title of the card
   * @param {Object} cardData.promo Object for promo card
   * @param {string} cardData.promo.caption The caption for the promo card
   * @param {Phaser.DisplayObject} cardData.promo.image The image for the promo card. Supposed to be drawn externally
   * @param {string} avatarImg The address of the user's avatar image
   */
  fillCard(cardData, avatarImg) {
    this._state = cardData.state;
    this.index = cardData.index;

    // Title
    const title = new G.Text(0, 0, OMT.language.getText(cardData.cardTitle), { style: 'eventPostcard-title', fontSize: 36 },
      0.5, this._innerDimensions.width, this._postcardSlice.top * 0.95, true, 'center');
    title.y = Math.round((this._card.y - (this._card.height / 2)) + (this._postcardSlice.top / 2));
    this.fillContainer.addChild(title);

    // Draws card based on state
    switch (this._state) {
      case POSTCARD_STATE.CLAIM:
        this._fillAsPromo(cardData);
        break;
      case POSTCARD_STATE.SEND:
        this._fillAsCard(cardData, avatarImg);
        break;
      default: break;
    }
  }

  /**
   * Draws the promo card using the given data
   * @param {Object} cardData
   * @param {Object} cardData.promo Object for promo card
   * @param {string} cardData.promo.caption The caption for the promo card
   * @param {Phaser.DisplayObject} cardData.promo.image The image for the promo card. Supposed to be drawn externally
   */
  _fillAsPromo(cardData) {
    if (!cardData.promo) { return; }

    // Button made first and positioned
    const theBigButton = this._makeButton('Claim');
    theBigButton.y = Math.round((this._card.height / 2) - theBigButton.height * 1.25);
    this._button = theBigButton;
    this._subFill.addChild(theBigButton);

    // Image is positioned next
    const img = cardData.promo.image;
    img.y = theBigButton.y - theBigButton.height - (img.height) / 2;
    this._subFill.addChild(img);

    // Leftover space is calculated and positioned so the caption can fit with maximum space
    const topPoint = this._postcardSlice.top - (this._border.height / 2);
    const leftoverSpace = (img.y - img.height / 2) - topPoint;
    const caption = new G.Text(0, 0, OMT.language.getText(cardData.promo.caption), 'eventPostcard-caption', 0.5, this._card.width * 0.8, leftoverSpace, true, 'center');
    caption.y = Math.round(topPoint + caption.height / 2);
    this._subFill.addChild(caption);
  }

  /**
   * Draws the card with the given data
   * @param {Object} cardData
   * @param {POSTCARD_STATE} cardData.state The state of the card
   * @param {number} cardData.index  The index of the card
   * @param {string} cardData.cardCaption The caption just above the button
   * @param {string} cardData.cardTitle The title of the card
   * @param {string} avatarImg The address of the user's avatar image
   */
  _fillAsCard(cardData, avatarImg) {
    const postcardData = G.OMTsettings.postcardEvent.cardData.postcardData[this.index];
    // Generate postcard image
    const postcardImage = G.makeExtImage(0, 0, postcardData.image, 'eventPostcard_PromoBg', 0.5, this._subFill, null, function assetResize() {
      this.height = 303;
      this.width = 371;
    });
    postcardImage.width = 371;
    postcardImage.height = 303;
    postcardImage.y = (this._postcardSlice.top * 1.25) - (this._border.height - postcardImage.height) / 2;

    // Draw the avatar
    const profileContainer = new OMT_UI_AvatarWithFrame(avatarImg, 90);
    this._subFill.addChild(profileContainer);
    profileContainer.x = profileContainer.width - (this._card.width / 2);
    profileContainer.y = (postcardImage.y + postcardImage.height / 2) + (profileContainer.height * 0.25);

    // Draw the speech bubble and text
    const speechSlice = G.OMTsettings.postcardEvent.cardData.speechBubble.slice;
    const leftoverSpeechSpace = this._innerDimensions.width - (profileContainer.x + profileContainer.width / 2) - speechSlice.right;
    const speechConstraints = {
      x: 20,
      width: (leftoverSpeechSpace * 0.65) - 20,
    };
    const speechText = new G.Text(speechConstraints.x, 0, OMT.language.getText(postcardData.speechText), 'font-white', 0.5, speechConstraints.width, profileContainer.height * 0.8, true, 'center');
    const bubble = this._makeSpeechBubble(leftoverSpeechSpace, speechSlice);
    bubble.x = Math.round(profileContainer.x + (profileContainer.width + bubble.width) / 2);
    bubble.y = Math.round(profileContainer.y);
    bubble.addChild(speechText);
    this._subFill.addChild(bubble);

    // Draw the big button
    const theBigButton = this._makeButton('Send');
    theBigButton.y = Math.round((this._card.height / 2) - theBigButton.height); // Temp spot
    this._button = theBigButton;

    // With the leftover space, make it for the caption
    const leftoverSpace = (theBigButton.y - theBigButton.height / 2) - (profileContainer.y + profileContainer.height / 2);
    const caption = new G.Text(0, 0, OMT.language.getText(cardData.cardCaption), 'eventPostcard-caption', 0.5, this._innerDimensions.width, leftoverSpace);
    caption.y = Math.round(profileContainer.y + (profileContainer.height + leftoverSpace) / 2);
    theBigButton.y = caption.y + (caption.height + theBigButton.height) / 2;

    this._subFill.addChild(caption);
    this._subFill.addChild(theBigButton);
  }

  /**
   * Function to create the button.
   * @param {string} text
   * @returns {OMT_UI_SquareButton}
   */
  _makeButton(text) {
    const theBigButton = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: this._innerDimensions.width,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText(text),
        textStyle: { style: 'font-white', fontSize: 48 },
      },
      options: {
        clickFunction: {
          onClick: this.onButtonClick.bind(this),
          disableAfterClick: this._state === POSTCARD_STATE.CLAIM, // Claim cards are disabled after click
        },
      },
    });
    return theBigButton;
  }

  /**
   *
   * @param {number} bodyWidth
   */
  _makeSpeechBubble(bodyWidth, slice) {
    const targetWidth = Math.round(bodyWidth) - slice.left - slice.right + 2;
    return OMT_UI_DrawUtil.drawNineSliceTileBox({
      spreadsheetName: 'eventPostcard',
      assetName: 'eventPostcardSpeech',
      sliceDimensions: slice,
      bodyWidth: targetWidth,
      offset: {
        left: 0.5,
        right: 1,
      },
    });
  }

  /**
   * Signal is dispatched when the button is clicked
   */
  onButtonClick() {
    this.signals.onClick.dispatch(this);
  }
}
